<template>
    <div>
        <div
            class="calendar-available-item-wrapper d-flex align-items-center clickable"
            @click="goToBook"
        >
            <BaseIcon
                name="calendar-alt"
                size="3x"
                class="d-flex flex-column justify-content-center"
                style="margin: 5px;"
            >
            </BaseIcon>
            <div
                class="calendar-available-item-content d-flex flex-column justify-content-center"
            >
                <h5>{{ data.title }}</h5>
                <span class="calendar-available-item-span">
                    {{ data.location }} | {{ data.duration }}
                    {{ $t('general.minutesShort') }}
                </span>
            </div>
        </div>
        <hr class="divider" />
    </div>
</template>

<script>
export default {
    name: 'AvailableAppointments',
    props: {
        data: {},
    },
    data: () => ({}),
    methods: {
        goToBook() {
            this.$router.push(
                this.$URLS.calendar
                    .concat(this.$URLS.book)
                    .concat('/')
                    .concat(this.data.id)
            );
        },
    },
};
</script>

<style scoped>
.calendar-available-item-wrapper {
    padding: 20px;
}
.calendar-available-item-content {
    margin-left: 20px;
}
.calendar-available-item-span {
    font-size: 14px;
    padding-top: 5px;
    color: #141414;
}
.first-available {
    color: var(--primary);
}
.divider {
    margin: 0;
    width: 100%;
    border-top: 1px solid #f3f3f3;
}
</style>
